function addProtocolToUrl(url) {
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
        url = 'http://' + url;
    }
    return url;
}

function mapsLoaded() {
    EntityOverview.initMap();
}

function slugify(str) {
    return str.toString().toLowerCase().trim()
        .replace(/&/g, '-and-')     // replace & with 'and'
        .replace(/[\s\W-]+/g, '-'); // replace spaces, non-word characters and dashes with a single dash (-)
}

/**
 * Return dutch price.
 *
 * @param str
 * @returns {*}
 */
function price(str) {

    if (str) {
        return Number(str).toLocaleString('nl-NL', {style: 'currency', currency: 'EUR'});
    }

    return 'Onbekend';
}

/**
 *
 * @param number
 * @param decimals
 * @returns {number}
 */
function roundNumber(number, decimals) {
    var multiplier = Math.pow(10, decimals || 0);
    return Math.round(number * multiplier) / multiplier;
}

function debounce(func, wait, immediate) {
    var timeout;

    return function () {
        var self = this,
            args = arguments;

        var later = function () {
            timeout = null;

            if (!immediate) {
                func.apply(self, args);
            }
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (immediate && !timeout) {
            func.apply(self, args);
        }
    };
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
    'use-strict';

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var YS = {
        // All pages
        'common': {
            init: function () {
                HeaderNav.init();
				CookieConsent.init();

                $('.fontsize-tooltip, .contrast-tooltip').tooltip();

                var fontsize = Cookies.get('fontsize');

                var toggleFontsizeClass = function (fontsize) {
                    var $body = $('body');

                    if (fontsize == 'large') {
                        $body.removeClass('fontsize-largest');
                        $body.addClass('fontsize-large');
                    } else if (fontsize == 'largest') {
                        $body.removeClass('fontsize-large');
                        $body.addClass('fontsize-largest');
                    } else {
                        $body.addClass('fontsize-normal');
                        $body.removeClass('fontsize-large');
                        $body.removeClass('fontsize-largest');
                    }

                    $(window).resize();
                };

                toggleFontsizeClass(fontsize);

                $('.fontsize-tooltip').click(function () {
                    if (fontsize == 'large') {
                        fontsize = 'largest';
                    } else if (fontsize == 'largest') {
                        fontsize = 'normal';
                    } else {
                        fontsize = 'large';
                    }

                    toggleFontsizeClass(fontsize);

                    Cookies.set('fontsize', fontsize);
                });

                var highContrast = Cookies.get('high-contrast');

                var toggleContrastClass = function (highContrast) {
                    var $body = $('body');

                    if (highContrast == 'yellow') {
                        $body.removeClass('high-contrast-white');
                        $body.addClass('high-contrast-yellow');
                    } else if (highContrast == 'white') {
                        $body.addClass('high-contrast-white');
                        $body.removeClass('high-contrast-yellow');
                    } else {
                        $body.addClass('high-contrast-off');
                        $body.removeClass('high-contrast-yellow');
                        $body.removeClass('high-contrast-white');
                    }
                };

                toggleContrastClass(highContrast);

                $('.contrast-toggle').click(function () {
                    if (highContrast == 'yellow') {
                        highContrast = 'white';
                    } else if (highContrast == 'white') {
                        highContrast = 'off';
                    } else {
                        highContrast = 'yellow';
                    }

                    toggleContrastClass(highContrast);

                    Cookies.set('high-contrast', highContrast);
                })

                /**
                 * Open all links into a new tab/window
                 */
                $('article .entry-content a').attr('target', '_blank');
            }
        },
        // Home page
        'home': {
            init: function () {
                $('.card-carousel').carousel();
            }
        },
        // Default content page
        'page_template_default': {
            init: function () {
                ContentPage.init();
            }
        },
        // Entity overview
        'page_template_template_entity': {
            init: function () {
                EntityOverview.init();

                $('.entity-tooltip').tooltip();
            }
        },
        'page_template_template_vraagbaak': {
            init: function () {
                ContentPage.init();

                var $content       = $('.page-content'),
                    $faqCategories = $content.find('.faq-categories'),
                    $titles        = $faqCategories.find('.faq-category-title');

                $titles.each(function () {
                    var title = $(this);

                    $faqCategories.find(title.data('toggle')).hide();
                });

                $titles.click(function () {
                    var title = $(this);

                    if (!title.hasClass('active')) {
                        //deactivate all titles
                        $titles.toggleClass('active', false);

                        //activate clicked title
                        title.toggleClass('active', true);

                        //hide all items
                        $faqCategories.find('.faq-items').hide();
                        ;

                        //show items for clicked title
                        $faqCategories.find(title.data('toggle')).show();
                    }
                });

                $titles.first().click();
            }
        },
        'page_template_template_stappenplan': {
            init: function () {
                var anchor = window.location.hash;

                $(window).load(function () {
                    $('a[href="' + anchor + '"]').removeClass('collapsed');
                    $(anchor).addClass('show');
                    $('html, body').animate({
                        scrollTop: $(anchor).offset().top - 205
                    }, 100);
                });

                $('.toggle-link').click(function () {
                    $(window).resize();
                });
            }
        },
        // Single entity
        'single': {
            init: function () {
                ContentPage.init();
                $('.entity-tooltip').tooltip();
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = YS;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery);
